const validateRadio = (response) => {
  return response !== "Yes";
};

export default validateRadio;
